import { MediaTypeObjectSchemaWithoutEncoding as OriginalMediaTypeObjectSchemaWithoutEncoding } from '../processed/media-type-object-without-encoding'

/**
 * Media Type Object (without encoding)
 *
 * Each Media Type Object provides schema and examples for the media type identified by its key.
 *
 * @see https://github.com/OAI/OpenAPI-Specification/blob/main/versions/3.1.1.md#media-type-object
 */
export const MediaTypeObjectSchemaWithoutEncoding = OriginalMediaTypeObjectSchemaWithoutEncoding
